import {
    CreativeTypes,
    VIDEO_MAX_DIMENSIONS,
    IMAGE_MAX_DIMENSIONS,
    VIDEO_MAX_CHARACTERS,
    IMAGE_MAX_CHARACTERS,
    CREATIVE_MAX_DURATION_SECONDS,
} from '@bynder-studio/render-core';
import { getEnvironment } from './getEnvironment';

export const envVar = {
    get wsEndpoint(): string {
        const env = getEnvironment();

        if (env === 'development') {
            return 'ws.development.weadapt.digital';
        }

        if (env === 'acceptance') {
            return 'ws.acceptance.weadapt.digital';
        }

        const { hostname } = window.location;

        if (hostname.includes('.eu.')) {
            return 'ws.eu.weadapt.digital';
        }

        if (hostname.includes('.us.')) {
            return 'ws.us.weadapt.digital';
        }

        return 'ws.weadapt.digital';
    },
    get googleAnalyticsId(): string {
        const env = getEnvironment();

        if (env === 'development') {
            return '';
        }

        if (env === 'acceptance') {
            return 'GTM-T4DZLS5';
        }

        return 'GTM-NL5BHHS';
    },
    appcuesAccountId: '17583',
    gatewayPrefix: '/gateway',
    sentryDsn: 'https://f087947988e143e2aeae6f16f6adf6f3@sentry10.bynder.cloud/1256',
    authRefreshTimeout: 600000,
    appVersionCheckIntervalSeconds: 3600,
    imageMaxDimensions: IMAGE_MAX_DIMENSIONS,
    videoMaxDimensions: VIDEO_MAX_DIMENSIONS,
    imageMaxCharacters: IMAGE_MAX_CHARACTERS,
    videoMaxCharacters: VIDEO_MAX_CHARACTERS,
    creativeMaxDurationSeconds: CREATIVE_MAX_DURATION_SECONDS,
    designMaxDimensions(creativeType: CreativeTypes) {
        return creativeType === CreativeTypes.VIDEO ? this.videoMaxDimensions : this.imageMaxDimensions;
    },
    designMaxCharacters(creativeType: CreativeTypes) {
        return creativeType === CreativeTypes.VIDEO ? this.videoMaxCharacters : this.imageMaxCharacters;
    },
};
